import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=0b9e1dfe&"
import script from "./IconButton.vue?vue&type=script&lang=ts&"
export * from "./IconButton.vue?vue&type=script&lang=ts&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=0b9e1dfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports